import { LocationViewModel } from '../../shared/viewModels/locationViewModel';

export class DashboardWeatherLocationViewModel {
  public location: LocationViewModel;
  public isDefault: boolean;
}
